import React from 'react';
import SectionText from '../presentational/SectionText';

import data from '../../core/data';

function HistoryContainer(props) {
  return (
    <section id="history" className="animated">
      <div className="container">
        <div className="row">
          <div className="col-md-4 body">
            <SectionText heading="A 50 Year History" body={ data.index.history.body } />
          </div>
        </div>
      </div>
    </section>
  )
}

//<div className="col-md-8 bb-flow no-margin hidden-xs"></div>
export default HistoryContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/HistoryContainer.jsx
 **/